import React from 'react';
import { Box, Typography } from '@mui/material';
import T from '../theme';
import { DataTable, InsightList, WhyThisMatters } from '../components/Shared.jsx';

export function ThemeMap({ data }) {
  const { themeClusters = [], performanceTable = [], competitiveContext, themeGaps = [], insights = [] } = data;

  return (
    <Box>
      {themeClusters.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Theme Clusters</Typography>
          {themeClusters.map((tc, i) => (
            <Box key={i} sx={{ mb: 1.5, p: 2, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                <Typography sx={{ fontWeight: 700, fontSize: 14, color: T.primary }}>{tc.theme}</Typography>
                <Box sx={{ px: 1.25, py: 0.4, background: 'rgba(249,115,22,0.2)', color: T.primary, borderRadius: 6, fontSize: 13, fontWeight: 700 }}>{tc.percentage}%</Box>
                <Typography sx={{ fontSize: 11, color: T.textSecondary }}>{tc.episodeCount} episodes</Typography>
              </Box>
              <Typography sx={{ fontSize: 12, color: T.textSecondary, mb: 0.75 }}>{tc.description}</Typography>
              {tc.keywords.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {tc.keywords.map((kw, j) => (
                    <Box key={j} sx={{ px: 1, py: 0.25, background: T.surface3, color: T.textSecondary, borderRadius: 4, fontSize: 11, border: `1px solid ${T.border}` }}>{kw}</Box>
                  ))}
                </Box>
              )}
            </Box>
          ))}
        </Box>
      )}

      {/* Performance by Theme — hidden until chart rank / OP3 data is reliably populated
      {performanceTable.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Performance by Theme</Typography>
          <DataTable
            columns={['Theme', 'Episodes', 'Avg Chart Rank', 'Avg OP3 7d', 'vs Average']}
            rows={performanceTable.map((pt) => [pt.theme, pt.episodeCount, pt.avgChartRank ?? '—', pt.avgOP37Day ?? '—', pt.vsShowAverage])}
          />
        </Box>
      )}
      */}

      {/* Competitive Context — hidden until chart rank / OP3 data feeds reliable context.
         Without real ranking data the AI just says "no data provided" or hallucinates comparisons.
         TODO 1.5: re-enable once competitiveContext contains real metrics. */}
      {/* competitiveContext && (
        <Box sx={{ mb: 3, p: 2, background: 'rgba(45,212,191,0.07)', border: `1px solid rgba(45,212,191,0.2)`, borderRadius: 1 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.accent, textTransform: 'uppercase', mb: 0.75 }}>Competitive Context</Typography>
          <Typography sx={{ fontSize: 13, color: T.textSecondary }}>{competitiveContext}</Typography>
        </Box>
      ) */}

      {themeGaps.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.warning, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1 }}>Theme Gaps</Typography>
          {themeGaps.map((tg, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.5, background: 'rgba(234,179,8,0.07)', border: `1px solid rgba(234,179,8,0.25)`, borderRadius: 1 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.text, mb: 0.25 }}>{tg.gap}</Typography>
              <Typography sx={{ fontSize: 12, color: T.textSecondary }}>Opportunity: {tg.opportunity}</Typography>
              <Typography sx={{ fontSize: 11, color: T.textSecondary, mt: 0.25, fontStyle: 'italic' }}>{tg.reasoning}</Typography>
            </Box>
          ))}
        </Box>
      )}

      <InsightList insights={insights} />
      <WhyThisMatters text="Understanding your content landscape helps optimize content strategy and SEO." citations={data.expertCitations} />
    </Box>
  );
}
